/**
 * 存储与读取
 */
export function saveLocal(k, v) {
  let user = window.localStorage[k];
  if (!user) {
    user = {};
  } else {
    user = JSON.parse(user);
  }
  user.key = v;
  window.localStorage[k] = JSON.stringify(user);
}
export function loadLocal(k, def) {
  let user = window.localStorage[k];
  if (!user) {
    return def;
  }
  user = JSON.parse(user);
  let ret = user.key;
  //之所以不用ret||def，是因为0||false是false
  return ret || def;
}
export function saveSession(k, v) {
  let user = window.sessionStorage[k];
  if (!user) {
    user = {};
  } else {
    user = JSON.parse(user);
  }
  user.key = v;
  window.sessionStorage[k] = JSON.stringify(user);
}
export function loadSession(k, def) {
  let user = window.sessionStorage[k];
  if (!user) {
    return def;
  }
  user = JSON.parse(user);
  let ret = user.key;
  //之所以不用ret||def，是因为0||false是false
  return ret || def;
}



// WEBPACK FOOTER //
// ./src/common/js/store.js